import { render, staticRenderFns } from "./button_part.vue?vue&type=template&id=5377064f&"
import script from "./button_part.vue?vue&type=script&lang=js&"
export * from "./button_part.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports